<script setup>
    import { useI18n } from 'vue-i18n';
    import {computed, unref} from "vue";
    import useLiferayLocale from '../../../composables/useLiferayLocale';

    const { t } = useI18n();
    const { urlLocaleParameter } = useLiferayLocale();

    const props = defineProps({
        title: {
            type: String,
            default: null,
        },

        abstract: {
            type: String,
            default: null,
        },

        linkHref: {
            type: String,
            default: null,
        },

        buttonLabel: {
            type: String,
            default: null,
        },

        backgroundImage: {
            type: String,
            default: null,
        }
    });

    const cardLink = computed(() =>
        props.linkHref?.startsWith('http')
            ? props.linkHref
            : `${unref(urlLocaleParameter)}${props.linkHref}`
    );

</script>

<template>
    <a :href="cardLink" class="news news-teaser-card card-content">
        <img :src="props.backgroundImage" class="background-image">
        <div class="card-content-container">
            <div class="title-container">
                <h2 class="article-text-title title is-2">{{ props.title }}</h2>
            </div>
            <div class="card-content-body">{{ props.abstract }}</div>
            <div class="button-container">
                <span class="button is-cream">{{ props.buttonLabel }}</span>
            </div>
        </div>
    </a>
</template>


<style lang="scss">
    @import '../../../../scss/variables';
    @import '../../../../scss/utilities/all';
    @import '../../../../scss/elements/title';

    .news-teaser-card {
        grid-column: span 3;
        grid-area: 2 / 1 / 2 / 4;
        overflow: hidden;

        @include mobile {
            grid-area: 1;
            grid-column: 1;
        }

        @include tablet-only {
            grid-area: 2 / 1 / 2 / 2;
            grid-column: span 2;
        }

        &:hover {
            box-shadow: 0 .5rem 1.5rem -.5rem rgba(0, 0, 0, .28);
            text-decoration: none;

            button {
                background-color: #fd5000;
                border-color: #fd5000;
                color: #fff;
            }
        }

        .background-image {
            -o-object-fit: cover;
            object-fit: cover;
            -o-object-position: center center;
            object-position: center center;
            position: absolute;
            left: 0;
            top: 0;

            @include mobile {
                height: 100%;
            }

            @include tablet-only {
                height: 100%;
            }
        }
    }
</style>
